import { ApplicationConfig, provideZoneChangeDetection, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { JWT_INTERCEPTOR_PROVIDERS } from './interceptors/jwt.interceptor.provider';
import {
  LUCIDE_ICONS, LucideIconProvider,
  ArrowLeftRight, Award, Bell, Bookmark, Building2, Calendar, Car, ChartColumn, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, ChevronsUpDown, CircleAlert, CircleCheck, CircleGauge, CircleHelp, CircleX, Clock, Eye, EyeOff,
  File, Filter, Fuel, Gauge, Gavel, Grid2x2, Heart, House, Info, Keyboard, List, Loader,
  Lock, LogOut, Mail, Menu, MessageSquare, Moon, MountainSnow, Package, Palette, Phone, RotateCcw, Search, Settings, Settings2, ShieldCheck,
  ShoppingCart, Star, Sun, Timer, TriangleAlert, User, Users, X, Zap,
} from 'lucide-angular';

import { routes } from './app.routes';
import { provideServiceWorker } from '@angular/service-worker';

const ICONS = {
  ArrowLeftRight, Award, Bell, Bookmark, Building2, Calendar, Car, ChartColumn, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, ChevronsUpDown, CircleAlert, CircleCheck, CircleGauge, CircleHelp, CircleX, Clock, Eye, EyeOff,
  File, Filter, Fuel, Gauge, Gavel, Grid2x2, Heart, House, Info, Keyboard, List, Loader,
  Lock, LogOut, Mail, Menu, MessageSquare, Moon, MountainSnow, Package, Palette, Phone, RotateCcw, Search, Settings, Settings2, ShieldCheck,
  ShoppingCart, Star, Sun, Timer, TriangleAlert, User, Users, X, Zap,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    JWT_INTERCEPTOR_PROVIDERS,
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    { provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(ICONS) },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
